export default {
    path : "officebuilding-item-all",
    name : "officebuilding-item-all",
    meta : {
        title : "全部项目"
    },
    component: () => import('@/pages/officebuilding/all/Index'),
    redirect: {
        name : "officebuilding-item-all-whole"
    },
    children: [
        {
            path: 'all',
            name: 'officebuilding-item-all-whole',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'officebuilding-item-all-recent',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'officebuilding-item-all-atme',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'officebuilding-item-all-meat',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'officebuilding-item-all-reply',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'officebuilding-item-all-search',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path : 'detail/:id',
            name : 'officebuilding-item-all-detail',
            metal: {
                title : '项目详细信息',
            },
            component: () => import('@/pages/itemCommon/Detail'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/officebuilding/allitem/index.js